<template>
  <div class="synonym">
      <div class="box">
          <div class="columns">
              <div class="column">
                <h1 class="title is-size-6">{{ (synonym.term ) }} <span class="speech">({{ synonym.partofspeech }})</span></h1>
                <span class="panel is-size-7" v-if="synonym.example.length > 0">
                  Example: {{ synonym.example }}
                </span>
              </div>
          </div>
          <div class="columns" v-if="synonym.synonyms.length > 0">
              <div class="column">
                  {{ synonym.synonyms }}
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name: 'Synonym',
    props: ['synonym']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

h1.title {
  margin-bottom: 8px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.speech {
  font-size: 1em;
  color: red;
}
</style>
